import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import {
    IndexEventsWidgetConfigState,
    initialIndexEventsConfiguration,
} from './config/IndexEventsWidgetConfigState';

export type IndexEventsWidgetState =
    WidgetWithConfigState<IndexEventsWidgetConfigState>;

export interface IndexEventsWidgetsState {
    [widgetKey: string]: IndexEventsWidgetState;
}

export const initialIndexEventsWidgetState: IndexEventsWidgetState = {
    config: initialIndexEventsConfiguration,
};

export const initialIndexEventsWidgetsState: IndexEventsWidgetsState = {};
